<template>
  <nav :class="['responsive-tab', tabStyle, customClass]">
    <ul ref="tabsList">
      <li v-for="tab in tabs" :key="tab.key">
        <a 
          :class="{ active: isTabActive(tab) }"
          href="javascript:void(0)"
          @click="handleTabClick(tab)"
        >
          {{ getTabLabel(tab) }}
          <div v-if="showCount(tab)" class="star-rating">
            <span class="avg">{{ getTabCount(tab) }}</span>
          </div>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "AssignmentTabs",
  props: {
    tabs: {
      type: Array,
      required: true
    },
    // Aktif tab'ı belirlemek için kullanılan değerler
    activeFilters: {
      type: Object,
      default: () => ({})
    },
    counts: {
      type: Object,
      default: () => ({})
    },
    tabStyle: {
      type: String,
      default: 'style-2'
    },
    customClass: {
      type: String,
      default: 'assignment-tabs'
    },
    minCountToShow: {
      type: Number,
      default: 0
    }
  },
  computed: {
    activeTabKey() {
      const activeTab = this.tabs.find(tab => this.isTabActive(tab))
      return activeTab ? activeTab.key : null
    }
  },
  watch: {
    activeTabKey: {
      immediate: true,
      handler() {
        this.$nextTick(() => this.centerActiveTab())
      }
    }
  },
  methods: {
    centerActiveTab() {
      if (typeof window === 'undefined' || !window.matchMedia('(max-width: 959px)').matches) {
        return
      }

      const tabsList = this.$refs.tabsList
      const activeTab = tabsList && tabsList.querySelector('a.active')
      if (!tabsList || !activeTab) return

      const tabsRect = tabsList.getBoundingClientRect()
      const activeTabRect = activeTab.getBoundingClientRect()
      const maxScrollLeft = Math.max(0, tabsList.scrollWidth - tabsList.clientWidth)
      const targetScrollLeft = Math.min(
        maxScrollLeft,
        Math.max(
          0,
          tabsList.scrollLeft +
            activeTabRect.left -
            tabsRect.left -
            (tabsList.clientWidth - activeTabRect.width) / 2
        )
      )
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

      if (typeof tabsList.scrollTo === 'function') {
        tabsList.scrollTo({
          left: targetScrollLeft,
          behavior: reduceMotion ? 'auto' : 'smooth'
        })
      } else {
        tabsList.scrollLeft = targetScrollLeft
      }
    },

    isTabActive(tab) {
      if (tab.isAll) {
        // "All" tab için özel kontrol
        return !this.activeFilters.just_assigned && 
               !this.activeFilters.on_progress && 
               !this.activeFilters.completed && 
               !this.activeFilters.repeat_it
      }
      
      // Normal tab'lar için filterKey veya key kullan
      const filterKey = tab.filterKey || tab.key
      return this.activeFilters[filterKey] === tab.value
    },
    handleTabClick(tab) {
      const filterKey = tab.filterKey || tab.key
      this.$emit('tab-change', {
        key: filterKey,
        value: tab.value,
        tab: tab
      })
    },
    getTabLabel(tab) {
      // Eğer label bir string ise ve $t ile çevrilebilir görünüyorsa çevir
      if (typeof tab.label === 'string' && this.$t) {
        return this.$t(tab.label)
      }
      return tab.label || tab.name || ''
    },
    showCount(tab) {
      if (!this.counts || !tab.countKey) return false
      const count = this.counts[tab.countKey]
      return count !== undefined && count !== null && count >= this.minCountToShow
    },
    getTabCount(tab) {
      if (!tab.countKey) return 0
      return this.counts[tab.countKey] || 0
    }
  }
}
</script>

<style scoped>
.star-rating {
  display: inline-block;
  margin-left: 5px;
}

.star-rating .avg {
  float: left;
  border-radius: 4px;
  background-color: #93949c;
  color: #fff;
  font-size: 11px;
  line-height: 1.2;
  font-weight: 300;
  padding: 3px 7px;
  position: relative;
  margin-right: 10px;
  margin-bottom: -4px;
}

.responsive-tab li a.active {
  color: #3e416d;
  opacity: 0.8;
}
</style>
